export enum Environment {
  Testing = 'testing',
  Staging = 'staging',
  Production = 'production'
}
